@if (form) {
  <form [formGroup]="form">
    <div class="inline-content" ngClass="{{ showFormErrors ? 'error' : '' }}">
      <shared-calendar-dropdown name="date" formControlName="date" [minDate]="minDate" [maxDate]="maxDate" [required]="required" />
      @if (dateTimeDelimiter) {
        <span>{{ dateTimeDelimiter }}</span>
      }
      @if (displayTime) {
        <shared-time-picker name="time" formControlName="time" [required]="required" />
      }
    </div>
    @if (showFormErrors) {
      <mat-error class="error-message">
        @if (form.errors?.dateRequired) {
          Date is required
        } @else if (form.errors?.timeRequired) {
          Time is required
        } @else if (form.errors?.dateOutOfRange) {
          {{ dateOutOfRangeError }}
        } @else {
          Invalid date or time
        }
      </mat-error>
    }
  </form>
}
